"use client";

import {isLoggedIn} from './utils';
import NavBar from './navbar';
import Login from './login';


const Home = () => {
    return isLoggedIn() ? <NavBar /> : <Login />;
}
export default Home
